export default {
    loadingReports: []
}